import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {Logo} from '..';

import intl from 'react-intl-universal';
import styles from './styles';

function handleContactClick(ev) {
  ev.preventDefault();

  window._urq.push(['Feedback_Open', 'submit/bug']);
}

function handleFeedbackClick(ev) {
  ev.preventDefault();

  window._urq.push(['Feedback_Open']);
}

export default class Footer extends PureComponent {

  render() {
    return (
      <div className={styles.footer}>
        <div className={styles.section}>
          <h4>{intl.get('Image Tools')}</h4>
          <Link to="/">{intl.get('Image Resize')}</Link>
          <Link to="/bulk-resize">{intl.get('Bulk Image Resize')}</Link>
          <Link to="/compress-images">{intl.get('Image Compressor')}</Link>
        </div>
        <div className={styles.section}>
          <h4>{intl.get('Features')}</h4>
          <Link to="/features/crop-photo">{intl.get('Photo Cropping')}</Link>
          <Link to="/features/photo-editor">{intl.get('Photo Editing')}</Link>
          <Link to="/features/compress-images">{intl.get('Photo Compressing')}</Link>
        </div>
        <div className={styles.section}>
          <h4>{intl.get('About')}</h4>
          <a href="#" onClick={handleContactClick}>{intl.get('Contact')}</a>
          {/* <Link to="/contact">{'Contact'}</Link> */}
          <Link to="/help">{intl.get('Help')}</Link>
          <a href="#" onClick={handleFeedbackClick}>{intl.get('Feedback')}</a>
        </div>
        <div className={styles.section}>
          <h4>{intl.get('Legal')}</h4>
          <Link to="/privacy">{intl.get('Privacy')}</Link>
          <Link to="/terms-of-service">{intl.get('Terms of Service')}</Link>
        </div>
        <div className={styles.section}>
          <Logo width={189} height={25} />
          &copy; 2013 - {`${(new Date()).getFullYear()} Imageresize.org`}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx